<template>
  <div class="scheme">
    <div class="topImg row">
      <div class="col-md-12">
        <img
          style="object-fit: cover;"
          :src="data.nav_pic"
          alt="南京小程序开发"
          title="南京小程序开发"
        />
        <div class="texts">
          <div>{{ data.nav_title }}</div>
          <div>{{ data.nav_desc }}</div>
        </div>
      </div>
    </div>

    <div class="cloud">
      <div class="row">
        <div class="col-md-8">
          <div class="title">
            云服务：计算、存储、网络、安全、部署、云通信、企业应用
          </div>
          <p>
            墨客云 提供了大量的全球性产品，其中包括计算、存储、数据库、分析、联网、移动产品、开发人员工具、管理工具、物联网、安全性和企业级应用程序。
            这些服务可帮助公司/组织快速发展、降低 IT
            成本以及进行扩展。很多大型企业和热门的初创公司都信任 信任
            www.mokyun.com，并通过，
            并通过这些服务为各种工作负载提供技术支持，其中包括 Web
            和移动互联网程序、行业应用、游戏开发、电商、数据处理与仓库、存储、存档及很多其他工作负载。
          </p>
        </div>
        <div class="col-md-4">
          <img
            draggable="false"
            src="../assets/undraw_podcast_q6p7.png"
            alt="南京app开发"
            title="南京app开发"
          />
        </div>
      </div>
    </div>

    <div class="zigBee">
      <div class="row">
        <div class="col-md-5">
          <img
            draggable="false"
            src="../assets/undraw_drone_delivery_5vrm.png"
            alt="南京小程序开发"
            title="南京小程序开发"
          />
        </div>
        <div class="col-md-7">
          <div class="title">物联网智能设备：产品研发与销售</div>
          <div class="secondary">连接</div>
          <p>
            提供全行业各种类型设备一站式物联接入的核心产品和服务，让设备物联入网上云不再是一件难事。
          </p>
          <p>
            联硬件产品组帮助各种移动和固定设备方便又稳定地发送数据，连接入网。提供高稳定可扩展的数据端到端通道，以及提供丰富的设备模型和解析服务。
          </p>
          <div class="secondary">应用</div>
          <p>
            数据化管理，满足用户多样化需求，使用户可以方便地分析和管理设备，提高生产效率。帮助用户方便高效地查看运行状况，分析预测故障，以及管理设备。
          </p>
          <div class="secondary">服务</div>
          <p>
            基于物联设备的大数据分析为机器画像，同时为设备及其拥有者提供差异性的保险、租赁等创新服务，客观、实时的解决行业痛点问题。
          </p>
        </div>
      </div>
    </div>

    <div class="software">
      <div class="row">
        <div class="col-md-8">
          <div class="title">
            移动互联网应用软件：APP、小程序、公众号、企业门户
          </div>
          <div class="secondary">小程序/公众号开发</div>
          <p>
            基于微信平台开发，共享9亿潜在用户，低成本高利润转化。公众号开发能力更强、可实现程度更高。小程序操作简便、使用流畅、推广方便。
          </p>
          <div class="secondary">企业门户</div>
          <p>企业官网，PC端的信息介绍平台。</p>
          <p>
            一站式需求开发，契合行业现状，紧抓行业痛点。全面覆盖移动终端，满足多个行业和多种商业模式的需求，App+小程序+微商城+网站的完整移动解决方案。
          </p>
        </div>
        <div class="col-md-4">
          <img
            draggable="false"
            src="../assets/undraw_organize_photos_d5nr.png"
            alt="南京小程序开发"
            title="南京小程序开发"
          />
        </div>
      </div>
    </div>

    <div class="use">
      <div class="row">
        <div class="col-md-5">
          <img
            draggable="false"
            src="../assets/undraw_mobile_apps_4wgf.png"
            alt="南京小程序开发"
            title="南京小程序开发"
          />
        </div>
        <div class="col-md-7">
          <div class="title">
            行业应用：企业移动CRM、智慧医疗、基于LBS智慧导览、智慧新零售、小程序门户
          </div>
          <p>
            分析行业市场、深度解析行业动向。根据行业痛点、按照客户需求设计行业相关的智慧解决方案。充分利用线上客户资源，转流量为可见盈利。
            把线下商户与新互联网概念结合，数据运营、智能分析，降低管理成本、提高运营效率。
          </p>
        </div>
      </div>
    </div>

    <div class="run">
      <div class="row">
        <div class="col-md-8">
          <div class="title">产品策划与运营：创意咨询服务以及产品运营服务</div>
          <p>
            品牌开发推广、活动策划，根据活动推广需求，量身定制有成效、趣味性的活动开发方案。为企业吸引转化可观的粉丝数及关注度，推进开展、达成活动预期效果。
          </p>
          <p>
            开发完成产品的运营维护与二次开发，基于现有产品进行数据运营、文案发布及数据维护。
          </p>
        </div>
        <div class="col-md-4">
          <img
            draggable="false"
            src="../assets/undraw_segmentation_uioo.png"
            alt="南京app开发"
            title="南京app开发"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import getData from '../api/getInfo';
export default {
  data() {
    return {
      data: {},
      scrollWatch: true,
    };
  },
  mounted() {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
    var _hmt = _hmt || [];
    (function() {
      var hm = document.createElement('script');
      hm.src = 'https://hm.baidu.com/hm.js?75d1af96b450c5590fffaae8357a65e0';
      var s = document.getElementsByTagName('script')[0];
      // s.parentNode.insertBefore(hm, s)

      // var bp = document.createElement('script');
      var curProtocol = window.location.protocol.split(':')[0];
      if (curProtocol === 'https')
        hm.src = 'https://zz.bdstatic.com/linksubmit/push.js';
      else hm.src = 'http://push.zhanzhang.baidu.com/push.js';
      // var s = document.getElementsByTagName("script")[0];
      s.parentNode.insertBefore(hm, s);
    })();
    this.separate();
    $(window).on('scroll', () => {
      if (this.scrollWatch) {
        this.onScroll();
      }
    });
    this.onScroll();
  },
  methods: {
    // 获取顶部图文信息
    separate() {
      // getData
      //   .separateImg()
      //   .then((res) => {
      let list = [
        {
          id: '1',
          nav_title: '解决方案',
          nav_pic: '1541475369769',
          nav_desc:
            '关注生活所关注的，了解商业所了解的，我们所做的一切，只是为了让科技改变生活。',
          sort: '6',
          appid: '23',
        },
        {
          id: '2',
          nav_title: '案例展示',
          nav_pic: '1541475386238',
          nav_desc:
            '根据行业现状按需定制，不做任何无用功，我们做的就是您想要的。',
          sort: '5',
          appid: '23',
        },
        {
          id: '6',
          nav_title: '功能',
          nav_pic: '1541488820596',
          nav_desc: '功能模块',
          sort: '4',
          appid: '23',
        },
        {
          id: '5',
          nav_title: '实验室',
          nav_pic: '1541475376231',
          nav_desc:
            '根据行业现状按需定制，不做任何无用功，我们做的就是您想要的。',
          sort: '3',
          appid: '23',
        },
        {
          id: '3',
          nav_title: '联系我们',
          nav_pic: '1541475595720',
          nav_desc:
            '去繁就简，留给你最好的体验，始终坚持契约精神，给我们一个机会，我们只会让你喜出望外。',
          sort: '2',
          appid: '23',
        },
        {
          id: '4',
          nav_title: '加入我们',
          nav_pic: '154147535974',
          nav_desc:
            '我们不仅仅是想做好研发，我们更想为这个蓬勃的互联网行业持续注入，开源精神，我们一直都在。',
          sort: '1',
          appid: '23',
        },
      ];
      list.forEach((v) => {
        if (v.nav_title == '解决方案') {
          this.data = v;
          this.data.nav_pic = `${getData.url}${v.nav_pic}`;
        }
      });
      // })
      // .catch((e) => {});
    },
    // 鼠标滚动
    onScroll() {
      let flow = {};
      flow.cloud = () => {
        $('.cloud .col-md-4').addClass('animated fadeInDown');
        $('.cloud .col-md-8').addClass('animated fadeInDown');
      };
      flow.zigBee = () => {
        $('.zigBee .col-md-5').addClass('animated fadeInDown');
        $('.zigBee .col-md-7').addClass('animated fadeInDown');
      };
      flow.software = () => {
        $('.software .col-md-4').addClass('animated fadeInDown');
        $('.software .col-md-8').addClass('animated fadeInDown');
      };
      flow.use = () => {
        $('.use .col-md-5').addClass('animated fadeInDown');
        $('.use .col-md-7').addClass('animated fadeInDown');
      };
      flow.run = () => {
        $('.run .col-md-4').addClass('animated fadeInDown');
        $('.run .col-md-8').addClass('animated fadeInDown');
      };
      // 执行动画
      this.judeSite(flow.cloud, $('.cloud'));
      this.judeSite(flow.zigBee, $('.zigBee'));
      this.judeSite(flow.software, $('.software'));
      this.judeSite(flow.use, $('.use'));
      this.judeSite(flow.run, $('.run'));
    },
    // 判断方案是否可见
    judeSite(fn, temp) {
      let result =
        temp.offset().top >= $(window).scrollTop() &&
        temp.offset().top < $(window).scrollTop() + $(window).height(); // 判断是否可见
      if (result) {
        setTimeout(() => {
          fn();
        }, 0);
      }
    },
  },
  destroyed() {
    this.scrollWatch = false;
  },
};
</script>
<style scoped>
.scheme {
  width: 100%;
  /*margin-top: 12vh !important;*/
}
.row {
  margin: 0;
  padding: 0;
}
.topImg {
  width: 100%;
}
.topImg .col-md-12 {
  width: 100%;
  padding: 0;
  position: relative;
}
.topImg img {
  width: 100%;
  height: 100%;
}
.topImg .texts {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.5);
}
.topImg .texts > div {
  width: 100%;
  text-align: center;
  color: #fff;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.topImg .texts > div:nth-child(1) {
  height: 60%;
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  justify-content: center;
  padding-bottom: 8px;
  font-size: 5rem;
  font-family: '黑体';
  font-weight: 600;
}
.topImg .texts > div:nth-child(2) {
  height: 40%;
  font-size: 15px;
  font-family: '黑体';
}

@media only screen and (min-width: 1100px) and (max-width: 1400px) {
  .topImg .texts > div:nth-child(1) {
    font-size: 3rem;
  }
  .topImg .texts > div:nth-child(2) {
    font-size: 13px;
  }
}
@media only screen and (min-width: 768px) and (max-width: 1100px) {
  .topImg .texts > div:nth-child(1) {
    font-size: 2rem;
  }
  .topImg .texts > div:nth-child(2) {
    font-size: 12px;
  }
}
@media only screen and (min-width: 768px) {
  .topImg {
    margin-top: 51px;
  }
}
@media only screen and (max-width: 768px) {
  .topImg .texts > div:nth-child(1) {
    font-size: 1.5rem;
  }
  .topImg .texts > div:nth-child(2) {
    font-size: 10px;
    padding: 0 12px;
  }
  .topImg {
    margin-top: 53px;
  }
}

@media only screen and (max-width: 768px) and (min-width: 680px) {
  .topImg .col-md-12 {
    height: 100px;
  }
}
@media only screen and (max-width: 680px) and (min-width: 460px) {
  .topImg .col-md-12 {
    height: 80px;
  }
}
@media (max-width: 460px) {
  .topImg .col-md-12 {
    height: 170px;
    object-fit: cover;
  }
}

.cloud {
  width: 100%;
  padding: 2.5em 0 1.8em;
  background: #fafafa;
  border-top: 0.1px solid #fafafa;
}
.cloud > div {
  width: 67%;
  margin: 2em auto 0;
}
.cloud .col-md-8 {
  min-height: 240px;
  font-family: MicrosoftYaHei-Bold;
  font-size: 1.6em;
  font-weight: normal;
  font-stretch: normal;
  line-height: 40px;
  letter-spacing: 0px;
  color: #666666;
}
.cloud .col-md-8 .title {
  margin-bottom: 1.3em;
}

.cloud .col-md-8 p {
  font-family: 'MicrosoftYaHei-Bold';
  font-size: 16px;
  line-height: 2em;
  color: #666;
}
.cloud > div > div img {
  width: 100%;
  height: 100%;
}
.zigBee {
  width: 100%;
  background: #fff;
  padding: 5em 0;
}
.zigBee > div {
  width: 67%;
  margin: 0 auto;
}
.zigBee .col-md-5 {
  margin: 8em 0 0;
}
.zigBee > div > div img {
  width: 100%;
  height: 100%;
}
.zigBee .col-md-7 .title {
  font-family: 'MicrosoftYaHei-Bold';
  font-size: 1.6em;
  line-height: 2.4em;
  color: #666;
  margin-bottom: 1.3em;
}
.zigBee .col-md-7 .secondary {
  font-family: 'microsoft yahei';
  font-size: 1.3em;
  line-height: 2.2em;
  color: #333;
}

.zigBee .col-md-7 p {
  font-family: 'MicrosoftYaHei-Bold';
  font-size: 16px;
  line-height: 2.5em;
  color: #666;
  margin-bottom: 1.2em;
}

.software {
  width: 100%;
  /*height: 540px;*/
  background: #fafafa;
  border-top: 0.1px solid #fafafa;
  padding: 4.8em 0;
}
.software > div {
  width: 67%;
  margin: 0 auto;
}
.software .col-md-8 .title {
  font-family: 'MicrosoftYaHei-Bold';
  font-size: 1.6em;
  line-height: 2em;
  color: #666;
  margin-bottom: 30px;
}
.software .col-md-8 .secondary {
  font-family: 'microsoft yahei';
  font-size: 20px;
  line-height: 40px;
  color: #333;
}
.software .col-md-8 p {
  font-family: 'MicrosoftYaHei-Bold';
  font-size: 16px;
  line-height: 40px;
  color: #666;
  margin-bottom: 20px;
}
.software .col-md-4 img {
  width: 100%;
  height: 100%;
}

.use {
  width: 100%;
  /*height: 484px;*/
  background: #fff;
  padding: 2.3em;
}
.use > div {
  width: 67%;
  /*height: 407px;*/
  margin: 0 auto;
}
.use .col-md-5 img {
  width: 100%;
  height: 100%;
}

.use .col-md-7 .title {
  font-family: 'MicrosoftYaHei-Bold';
  font-size: 1.6em;
  line-height: 2em;
  color: #666;
  margin-bottom: 1.3em;
}
.use .col-md-7 p {
  font-family: 'MicrosoftYaHei-Bold';
  font-size: 16px;
  line-height: 2em;
  color: #666;
}

.run {
  width: 100%;
  /*height: 484px;*/
  background: #fafafa;
  padding: 4.7em 0 3.2em;
}
.run > div {
  width: 67%;
  margin: 0 auto;
}
.run .col-md-8 .title {
  font-family: 'MicrosoftYaHei-Bold';
  font-size: 1.6em;
  line-height: 2em;
  color: #666;
  margin-bottom: 1.5em;
}
.run .col-md-8 p {
  font-family: 'MicrosoftYaHei-Bold';
  font-size: 16px;
  line-height: 2em;
  color: #666;
}
.run .col-md-4 img {
  width: 100%;
  height: 100%;
}
@media only screen and (max-width: 992px) {
  .scheme > div > .row {
    width: 95%;
  }
  .cloud .col-md-8 {
    font-size: 1.2em;
    line-height: 25px;
  }
  .cloud .col-md-8 p {
    font-size: 13px;
  }
  .zigBee {
    padding: 0;
  }
  .zigBee .col-md-7 .title {
    font-size: 1.2em;
    line-height: 25px;
  }
  .zigBee .col-md-7 .secondary {
    font-size: 1.1em;
  }
  .zigBee .col-md-7 p {
    font-size: 13px;
    line-height: 2em;
  }
  .software .col-md-8 .title {
    font-size: 1.2em;
    line-height: 25px;
  }
  .software .col-md-8 .secondary {
    font-size: 1.1em;
  }
  .software .col-md-8 p {
    font-size: 13px;
    line-height: 2em;
  }

  .use {
    padding: 0;
  }
  .use .col-md-7 .title {
    font-size: 1.2em;
    line-height: 25px;
  }
  .use .col-md-7 .secondary {
    font-size: 1.1em;
  }
  .use .col-md-7 p {
    font-size: 13px;
    line-height: 2em;
  }
  .run .col-md-8 .title {
    font-size: 1.2em;
    line-height: 25px;
  }
  .run .col-md-8 .secondary {
    font-size: 1.1em;
  }
  .run .col-md-8 p {
    font-size: 13px;
    line-height: 2em;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/scheme.vue